import store from "../store";
import Constants from "../config/constants";


import { serviceExpenseGetList, serviceExpenseApprove} from "../services/ExpenseManager.service";
import EventEmitter from "../libs/Events.utils";

export const FETCH_INIT = "FETCH_INIT_EXPENSE_MANAGER";
export const FETCHED = "FETCHED_EXPENSE_MANAGER";
export const FETCHED_FAIL = "FETCHED_FAIL_EXPENSE_MANAGER";
export const FETCHED_FILTER = "FETCHED_FILTER_EXPENSE_MANAGER";
export const FETCH_NEXT = "FETCH_NEXT_EXPENSE_MANAGER";
export const FILTER = "FILTER_EXPENSE_MANAGER";
export const RESET_FILTER = "RESET_FILTER_EXPENSE_MANAGER";
export const SET_SORTING = "SET_SORTING_EXPENSE_MANAGER";
export const SET_FILTER = "SET_FILTER_EXPENSE_MANAGER";
export const SET_PAGE = "SET_PAGE_EXPENSE_MANAGER";
export const CHANGE_PAGE = "CHANGE_PAGE_EXPENSE_MANAGER";
export const CHANGE_STATUS = "CHANGE_STATE_EXPENSE_MANAGER";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_EXPENSE_MANAGER";
export const CREATE_DATA = "CREATE_EXPENSE_MANAGER";
export const UPDATE_DATA = "UPDATE_EXPENSE_MANAGER";
export const DELETE_ITEM = "DELETE_EXPENSE_MANAGER";
export const SET_OTHER_DATA = "SET_OTHER_DATA_EXPENSE_MANAGER";

export function actionFetchExpenseList(
  index = 1,
  sorting = {},
  filter = {},
  otherData = {},
  options = {}
) {
  const request = serviceExpenseGetList({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
    ...otherData,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (Object.keys(otherData).length > 0) {
        dispatch({ type: SET_OTHER_DATA, payload: otherData });
      } else {
        dispatch({ type: SET_OTHER_DATA, payload: {} });
      }
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index, ...options } });
        if (!options.preservePage) { dispatch({ type: SET_SERVER_PAGE, payload: index }); }
        if (index == 1 && !options.preservePage) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionCreateNewEmployeeList(data) {
  const request = serviceExpenseApprove(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {
          error: "Saved",
          type: "success",
        });
        dispatch({ type: CREATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionChangePageExpenseList(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterExpenseList(value) {
  const request = null;
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null });
    });
  };
}

export function actionChangeStatusExpenseList(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterExpenseList() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageExpenseList(page, extraPayload = {}) {
  const stateData = store.getState().expense_request;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;
  const otherData = stateData.other_data;
  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchExpenseList(
        serverPage + 1,
        sortingData,
        { query, query_data: queryData, ...extraPayload },
        otherData
      )
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
